const ASC = 'asc';
const DESC = 'desc';

export enum EOrder {
  asc = ASC,
  desc = DESC,
}
